import { useWivTeaserHandler } from '@frontend/self-upgrade';
import { useGetHasInsuranceVerificationAccess } from './use-get-has-insurance-verification-access';
import { useGetIsValidInsuranceVertical } from './use-get-is-valid-insurance-vertical';

interface InsuranceSectionDisplayState {
  isLoading: boolean;
  showInsurance: boolean;
  showNoInsuranceAccessMessage: boolean;
  showWeaveVerifyPromotion: boolean;
}

export const useShouldShowInsurance = (locationId: string): InsuranceSectionDisplayState => {
  const {
    isLoading,
    showWeaveVerify: isWeaveVerifyFeatureOn,
    showWeaveVerifyPromotion: isWeaveVerifyPromotion,
  } = useWivTeaserHandler({ locationIds: [locationId] });

  const { hasWeaveInsuranceVerificationFullAccess, allChildLocationIdDoNotHaveAccess, isMultiLocation } =
    useGetHasInsuranceVerificationAccess(locationId);

  const isValidInsuranceVertical = useGetIsValidInsuranceVertical(locationId);

  let showNoInsuranceAccessMessage = false,
    showWeaveVerifyPromotion = false,
    showInsurance = false;
  /*
    Determine if there's no access to the insurance section
    No access if:
    1. It's a multi-location setup AND all child locations lack access.
    2. It's a single location AND it doesn't have the required ACLs (Access Control Lists).
    */
  const noInsuranceAccess = isMultiLocation
    ? allChildLocationIdDoNotHaveAccess
    : !hasWeaveInsuranceVerificationFullAccess;
  /**
     * Determine if a "no insurance access" message should be displayed. This message is shown only if it's a multi-location setup where child locations
     do have insurance access, but the current specific location does not.
    */
  const isNoInsuranceAccessMessage =
    isMultiLocation && !allChildLocationIdDoNotHaveAccess && !hasWeaveInsuranceVerificationFullAccess;
  /** 
 Below If condition proceeds only if:
  1. The data for the 'Weave Verify' feature is not loading (`!isLoading`).
  2. The detected insurance vertical (Dental, Wellness, Other) is valid (`isValidInsuranceVertical`).
  3. The current location or its child locations have general access to the insurance features
  4. Ones above condition gets passed based on customization flag will decide whether to show respective card or tab
 */
  if (!isLoading && isValidInsuranceVertical && !noInsuranceAccess) {
    if (isWeaveVerifyFeatureOn) {
      showInsurance = true;
    }
    //weaveVerifyPromotion is shown when `isWeaveVerifyFeatureOn` is off and user is eligibile for trial
    if (isWeaveVerifyPromotion) {
      showInsurance = true;
      showWeaveVerifyPromotion = true;
    }
    if (isNoInsuranceAccessMessage) {
      showNoInsuranceAccessMessage = true;
    }
  }
  return {
    isLoading,
    showInsurance,
    showNoInsuranceAccessMessage,
    showWeaveVerifyPromotion,
  };
};
